<template>
    <div class="piscreen">
    <!-- <div class="touchscreen-outer"> -->
        <!-- <div class="touchscreen"> -->
            
        <div class="topBar" id="top">
            <div class="home active">
                <a href="/"><font-awesome-icon icon="home" /></a>
            </div>
            <div class="home">
                <a href="/leaderboard"><font-awesome-icon icon="trophy" /></a>
            </div>

            <div class="home">
                <a href="/playeroptions"><font-awesome-icon icon="user-cog" /></a>
            </div>

            <div class="home">
                <a href="/playermilestones"><font-awesome-icon icon="user-check" /></a>
            </div>
            
            <div style="flex-grow: 1; text-align: right; padding-right: 16px; margin-top: 8px">
                <span style="font-size: 1em; font-weight: normal; padding-right: 1px">seizoen</span>
                <h1 style="margin-top: -6px">
                    {{ season.name }}
                </h1>
            </div>
            


        </div>

        <nav class="categories">
            <div class="nav-cat" @click="scrollTo('top')">
                <div><font-awesome-icon icon="arrow-up" /></div>
            </div>
            <div class="nav-cat" @click="scrollTo('singles')">
                <div>Singles</div>
            </div>
            <div class="nav-cat" @click="scrollTo('doubles2x')">
                <div>Doubles<br>(2x)</div>
            </div>
            <div class="nav-cat" @click="scrollTo('doubles3x')">
                <div>Doubles<br>(3x)</div>
            </div>
            <div class="nav-cat" @click="scrollTo('triples2x')">
                <div>Triples<br>(2x)</div>
            </div>
            <div class="nav-cat" @click="scrollTo('triples3x')">
                <div>Triples<br>(3x)</div>
            </div>
            <div class="nav-cat" @click="scrollTo('shanghai')">
                <div>Shanghai</div>
            </div>
            <div class="nav-cat" @click="scrollTo('robinhood')">
                <div>Robin<br>Hood</div>
            </div>
            <div class="nav-cat" @click="scrollTo('bull')">
                <div>Bull</div>
            </div>
        </nav>

        <!-- SINGLES -->
        <div class="category singles" id="singles">
            <header>
                <h2>Singles</h2>
                <p>3 darts in hetzelfde getal</p>
            </header>
            <div class="addButton"><a href="/editmilestones?cat=singles">+</a></div>
            <div class="player" v-for="player in singles" v-if="player.score.length > 0">
                <div class="name">
                    {{ player.name }}
                </div>
                <div class="milestones">
                    <table>
                        <tr>
                            <td v-for="n in 20" v-bind:class="{ enabled: player.score.includes(String(n)) }">{{ n }}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>

        <!-- DOUBLES 2X -->
        <div class="category intermediate" id="doubles2x">
            <header>
                <h2>Doubles (2x)</h2>
                <p>2 darts in dezelfde double</p>
            </header>
            <div class="addButton"><a href="/editmilestones?cat=doubles2x">+</a></div>
            <div class="player" v-for="player in doubles2x" v-if="player.score.length > 0">
                <div class="name">
                    {{ player.name }}
                </div>
                <div class="milestones">
                    <table>
                        <tr>
                            <td v-for="n in 20" v-bind:class="{ enabled: player.score.includes(String(n)) }">{{ n }}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>

        <!-- DOUBLES 3X -->
        <div class="category hard" id="doubles3x">
            <header>
                <h2>Doubles (3x)</h2>
                <p>3 darts in dezelfde double</p>
            </header>
            <div class="addButton"><a href="/editmilestones?cat=doubles3x">+</a></div>
            <div class="player" v-for="player in doubles3x" v-if="player.score.length > 0">
                <div class="name">
                    {{ player.name }}
                </div>
                <div class="milestones">
                    <table>
                        <tr>
                            <td v-for="n in 20" v-bind:class="{ enabled: player.score.includes(String(n)) }">{{ n }}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>

        <!-- TRIPLES 2X -->
        <div class="category intermediate" id="triples2x">
            <header>
                <h2>Triples (2x)</h2>
                <p>2 darts in dezelfde triple</p>
            </header>
            <div class="addButton"><a href="/editmilestones?cat=triples2x">+</a></div>
            <div class="player" v-for="player in triples2x" v-if="player.score.length > 0">
                <div class="name">
                    {{ player.name }}
                </div>
                <div class="milestones">
                    <table>
                        <tr>
                            <td v-for="n in 20" v-bind:class="{ enabled: player.score.includes(String(n)) }">{{ n }}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>

        <!-- TRIPLES 3X -->
        <div class="category hard" id="triples3x">
            <header>
                <h2>Triples (3x)</h2>
                <p>3 darts in dezelfde triple</p>
            </header>
            <div class="addButton"><a href="/editmilestones?cat=triples3x">+</a></div>
            <div class="player" v-for="player in triples3x" v-if="player.score.length > 0">
                <div class="name">
                    {{ player.name }}
                </div>
                <div class="milestones">
                    <table>
                        <tr>
                            <td v-for="n in 20" v-bind:class="{ enabled: player.score.includes(String(n)) }">{{ n }}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>

        <!-- SHANGHAI -->
        <div class="category hard" id="shanghai">
            <header>
                <h2>Shanghai</h2>
                <p>Een single, double en triple in hetzelfde getal</p>
            </header>
            <div class="addButton"><a href="/editmilestones?cat=shanghai">+</a></div>
            <div class="player" v-for="player in shanghai" v-if="player.score.length > 0">
                <div class="name">
                    {{ player.name }}
                </div>
                <div class="milestones">
                    <table>
                        <tr>
                            <td v-for="n in 20" v-bind:class="{ enabled: player.score.includes(String(n)) }">{{ n }}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>

        <!-- ROBIN HOOD -->
        <div class="category hard" id="robinhood">
            <header>
                <h2>Robin Hood</h2>
                <p>Gooi een dart in een getal, en dan een dart achter in de 1<sup>e</sup> dart</p>
            </header>
            <div class="addButton"><a href="/editmilestones?cat=robinhood">+</a></div>
            <div class="player" v-for="player in robinhood" v-if="player.score.length > 0">
                <div class="name">
                    {{ player.name }}
                </div>
                <div class="milestones">
                    <table>
                        <tr>
                            <td v-for="n in 20" v-bind:class="{ enabled: player.score.includes(String(n)) }">{{ n }}</td>
                            <td v-bind:class="{ enabled: player.score.includes('bull') }">
                                <!-- BULL -->
                                <span class="bull-icon hit"></span>
                            </td>
                            <td v-bind:class="{ enabled: player.score.includes('bullseye') }">
                                <!-- BULLSEYE -->
                                <span class="bullseye-icon hit"></span>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>

        <!-- BULL -->
        <div class="category hard" id="bull">
            <header>
                <h2>Bull</h2>
                <p>1 of meerdere darts in de bull of bullseye</p>
            </header>
            <div class="addButton"><a href="/editmilestones?cat=bull">+</a></div>
            <div class="player" v-for="player in bull" v-if="player.score.length > 0">
                <div class="name">
                    {{ player.name }}
                </div>
                <div class="milestones">
                    <table class="bull">
                        <tr>
                            
                            <td v-bind:class="{ enabled: player.score.includes('G') }">
                                <!-- BULL -->
                                <span class="bull-icon hit"></span>
                            </td>
                            <td v-bind:class="{ enabled: player.score.includes('GG') }">
                                <!-- BULL -->
                                <span class="bull-icon hit"></span>
                                <!-- BULL -->
                                <span class="bull-icon hit"></span>
                            </td>
                            <td v-bind:class="{ enabled: player.score.includes('GGG') }">
                                <!-- BULL -->
                                <span class="bull-icon hit"></span>
                                <!-- BULL -->
                                <span class="bull-icon hit"></span>
                                <!-- BULL -->
                                <span class="bull-icon hit"></span>
                            </td>
                            <td v-bind:class="{ enabled: player.score.includes('R') }">
                                <!-- BULLSEYE -->
                                <span class="bullseye-icon hit"></span>
                            </td>
                            <td v-bind:class="{ enabled: player.score.includes('RR') }">
                                <!-- BULLSEYE -->
                                <span class="bullseye-icon hit"></span>
                                <!-- BULLSEYE -->
                                <span class="bullseye-icon hit"></span>
                            </td>
                            <td v-bind:class="{ enabled: player.score.includes('RRR') }">
                                <!-- BULLSEYE -->
                                <span class="bullseye-icon hit"></span>
                                <!-- BULLSEYE -->
                                <span class="bullseye-icon hit"></span>
                                <!-- BULLSEYE -->
                                <span class="bullseye-icon hit"></span>
                            </td>
                            <td v-bind:class="{ enabled: player.score.includes('GR') }">
                                <!-- BULL -->
                                <span class="bull-icon hit"></span>
                                <!-- BULLSEYE -->
                                <span class="bullseye-icon hit"></span>
                            </td>
                            <td v-bind:class="{ enabled: player.score.includes('GGR') }">
                                <!-- BULL -->
                                <span class="bull-icon hit"></span>
                                <!-- BULL -->
                                <span class="bull-icon hit"></span>
                                <!-- BULLSEYE -->
                                <span class="bullseye-icon hit"></span>
                            </td>
                            <td v-bind:class="{ enabled: player.score.includes('GRR') }">
                                <!-- BULL -->
                                <span class="bull-icon hit"></span>
                                <!-- BULLSEYE -->
                                <span class="bullseye-icon hit"></span>
                                <!-- BULLSEYE -->
                                <span class="bullseye-icon hit"></span>
                            </td>


                            
                            


                        </tr>
                    </table>
                </div>
            </div>
        </div>
        
        <div class="bottomMenu">
            <!-- <a class="menuButton optionsButton"><font-awesome-icon icon="cog" /></a> -->
            <a href="/admin"><img src="@/assets/aletho-logo.png" width="58" height="58" class="logo" /></a>
            <div class="footerText" @click="adminCounter2()">
                <p>Alétho Darts Hall of Fame</p>
                <p>{{ version }}</p>
                <!-- <p>Copyright Frank van Deemter</p> -->
            </div>
            
            <!-- <div class="powerButton"><font-awesome-icon icon="info" /></div> -->
            <div class="patchnotes"><a href="/patchnotes"><font-awesome-icon :icon="['far', 'file-alt']" /></a></div>
            <!-- <font-awesome-icon :icon="['far', 'calendar-check']" /> -->

        </div>

    </div>

</template>

<script>

import axios from 'axios'

export default {

    name: 'Milestones',

    data() {
        return {
            version: 'versie 1.5.1',
            test: true,
            season: {
                id: 0,
                name: ''
            },
            players: [],
            singles: [],
            doubles2x: [],
            doubles3x: [],
            triples2x: [],
            triples3x: [],
            shanghai: [],
            robinhood: [],
            bull: [],
            
            milestonesLoaded: 0,
            category: '',
            fullscreen: true
        }
        
    },

    
    methods: {
        
        scrollTo(cat) {
            let el = document.getElementById(cat);
            let yOffset = el.offsetTop;
            window.scroll({
                top: yOffset - 68, 
                left: 0, 
                behavior: 'smooth'
            });
        },

        getMilestones() {
            this.milestonesLoaded = 0;
            this.getSingles();
            this.getDoubles2x();
            this.getDoubles3x();
            this.getTriples2x();
            this.getTriples3x();
            this.getShanghai();
            this.getRobinhood();
            this.getBull();
        },
        
        milestoneLoaded() {
            this.milestonesLoaded++;
            let self = this;

            if (this.milestonesLoaded == 8 && this.category) {
                setTimeout(function() {
                    self.scrollTo(self.category);
                }, 500)
                
            }
        },

        getSingles() {
            const params = {
                params: {
                    category: 'singles'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category.php', params).then(function (response) {
                console.log(response);
                
                for (let i = 0; i < response.data.length; i++) {
                    for (let p = 0; p < self.players.length; p++) {
                        if (response.data[i].user_id == self.players[p].id && response.data[i].season_id == self.season.id) {
                            self.players[p].singles.push(response.data[i].score);
                        }
                    }
                }

                let singles = [];
                for (let i = 0; i < self.players.length; i++) {
                    singles.push({
                        id: self.players[i].id,
                        name: self.players[i].name,
                        score: self.players[i].singles
                    })
                }
                singles.sort(function(a, b){
                    if (a.score.length < b.score.length) return 1;
                    if (a.score.length > b.score.length) return -1;
                    if (a.name > b.name) return 1;
                    if (a.name < b.name) return -1;
                });
                self.singles = singles;

                self.milestoneLoaded();
            }).catch(function (error) {
                console.log(error);
            });
        },

        getDoubles2x() {
            const params = {
                params: {
                    category: 'doubles_2x'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category.php', params).then(function (response) {
                console.log(response);
                for (let i = 0; i < response.data.length; i++) {
                    for (let p = 0; p < self.players.length; p++) {
                        if (response.data[i].user_id == self.players[p].id && response.data[i].season_id == self.season.id) {
                            self.players[p].doubles2x.push(response.data[i].score);
                        }
                    }
                }

                let doubles2x = [];
                for (let i = 0; i < self.players.length; i++) {
                    doubles2x.push({
                        id: self.players[i].id,
                        name: self.players[i].name,
                        score: self.players[i].doubles2x
                    })
                }
                doubles2x.sort(function(a, b){
                    if (a.score.length < b.score.length) return 1;
                    if (a.score.length > b.score.length) return -1;
                    if (a.name > b.name) return 1;
                    if (a.name < b.name) return -1;
                });
                self.doubles2x = doubles2x;

                self.milestoneLoaded();
            }).catch(function (error) {
                console.log(error);
            });
        },

        getDoubles3x() {
            const params = {
                params: {
                    category: 'doubles_3x'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category.php', params).then(function (response) {
                console.log(response);
                for (let i = 0; i < response.data.length; i++) {
                    for (let p = 0; p < self.players.length; p++) {
                        if (response.data[i].user_id == self.players[p].id && response.data[i].season_id == self.season.id) {
                            self.players[p].doubles3x.push(response.data[i].score);
                        }
                    }
                }

                let doubles3x = [];
                for (let i = 0; i < self.players.length; i++) {
                    doubles3x.push({
                        id: self.players[i].id,
                        name: self.players[i].name,
                        score: self.players[i].doubles3x
                    })
                }
                doubles3x.sort(function(a, b){
                    if (a.score.length < b.score.length) return 1;
                    if (a.score.length > b.score.length) return -1;
                    if (a.name > b.name) return 1;
                    if (a.name < b.name) return -1;
                });
                self.doubles3x = doubles3x;

                self.milestoneLoaded();
            }).catch(function (error) {
                console.log(error);
            });
        },

        getTriples2x() {
            const params = {
                params: {
                    category: 'triples_2x'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category.php', params).then(function (response) {
                console.log(response);
                for (let i = 0; i < response.data.length; i++) {
                    for (let p = 0; p < self.players.length; p++) {
                        if (response.data[i].user_id == self.players[p].id && response.data[i].season_id == self.season.id) {
                            self.players[p].triples2x.push(response.data[i].score);
                        }
                    }
                }

                let triples2x = [];
                for (let i = 0; i < self.players.length; i++) {
                    triples2x.push({
                        id: self.players[i].id,
                        name: self.players[i].name,
                        score: self.players[i].triples2x
                    })
                }
                triples2x.sort(function(a, b){
                    if (a.score.length < b.score.length) return 1;
                    if (a.score.length > b.score.length) return -1;
                    if (a.name > b.name) return 1;
                    if (a.name < b.name) return -1;
                });
                self.triples2x = triples2x;

                self.milestoneLoaded();
            }).catch(function (error) {
                console.log(error);
            });
        },

        getTriples3x() {
            const params = {
                params: {
                    category: 'triples_3x'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category.php', params).then(function (response) {
                console.log(response);
                for (let i = 0; i < response.data.length; i++) {
                    for (let p = 0; p < self.players.length; p++) {
                        if (response.data[i].user_id == self.players[p].id && response.data[i].season_id == self.season.id) {
                            self.players[p].triples3x.push(response.data[i].score);
                        }
                    }
                }

                let triples3x = [];
                for (let i = 0; i < self.players.length; i++) {
                    triples3x.push({
                        id: self.players[i].id,
                        name: self.players[i].name,
                        score: self.players[i].triples3x
                    })
                }
                triples3x.sort(function(a, b){
                    if (a.score.length < b.score.length) return 1;
                    if (a.score.length > b.score.length) return -1;
                    if (a.name > b.name) return 1;
                    if (a.name < b.name) return -1;
                });
                self.triples3x = triples3x;

                self.milestoneLoaded();
            }).catch(function (error) {
                console.log(error);
            });
        },

        getShanghai() {
            const params = {
                params: {
                    category: 'shanghai'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category.php', params).then(function (response) {
                console.log(response);
                for (let i = 0; i < response.data.length; i++) {
                    for (let p = 0; p < self.players.length; p++) {
                        if (response.data[i].user_id == self.players[p].id && response.data[i].season_id == self.season.id) {
                            self.players[p].shanghai.push(response.data[i].score);
                        }
                    }
                }

                let shanghai = [];
                for (let i = 0; i < self.players.length; i++) {
                    shanghai.push({
                        id: self.players[i].id,
                        name: self.players[i].name,
                        score: self.players[i].shanghai
                    })
                }
                shanghai.sort(function(a, b){
                    if (a.score.length < b.score.length) return 1;
                    if (a.score.length > b.score.length) return -1;
                    if (a.name > b.name) return 1;
                    if (a.name < b.name) return -1;
                });
                self.shanghai = shanghai;

                self.milestoneLoaded();
            }).catch(function (error) {
                console.log(error);
            });
        },

        getRobinhood() {
            const params = {
                params: {
                    category: 'robinhood'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category.php', params).then(function (response) {
                console.log(response);
                for (let i = 0; i < response.data.length; i++) {
                    for (let p = 0; p < self.players.length; p++) {
                        if (response.data[i].user_id == self.players[p].id && response.data[i].season_id == self.season.id) {
                            self.players[p].robinhood.push(response.data[i].score);
                        }
                    }
                }

                let robinhood = [];
                for (let i = 0; i < self.players.length; i++) {
                    robinhood.push({
                        id: self.players[i].id,
                        name: self.players[i].name,
                        score: self.players[i].robinhood
                    })
                }
                robinhood.sort(function(a, b){
                    if (a.score.length < b.score.length) return 1;
                    if (a.score.length > b.score.length) return -1;
                    if (a.name > b.name) return 1;
                    if (a.name < b.name) return -1;
                });
                self.robinhood = robinhood;

                self.milestoneLoaded();
            }).catch(function (error) {
                console.log(error);
            });
        },

        getBull() {
            const params = {
                params: {
                    category: 'bull'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category.php', params).then(function (response) {
                console.log(response);
                for (let i = 0; i < response.data.length; i++) {
                    for (let p = 0; p < self.players.length; p++) {
                        if (response.data[i].user_id == self.players[p].id && response.data[i].season_id == self.season.id) {
                            self.players[p].bull.push(response.data[i].score);
                        }
                    }
                }

                let bull = [];
                for (let i = 0; i < self.players.length; i++) {
                    bull.push({
                        id: self.players[i].id,
                        name: self.players[i].name,
                        score: self.players[i].bull
                    })
                }
                bull.sort(function(a, b){
                    if (a.score.length < b.score.length) return 1;
                    if (a.score.length > b.score.length) return -1;
                    if (a.name > b.name) return 1;
                    if (a.name < b.name) return -1;
                });
                self.bull = bull;

                self.milestoneLoaded();
            }).catch(function (error) {
                console.log(error);
            });
        },

        loadUsers() {
            const params = {
                params: {
                    // user_id: '1'
                }
            }

            const self = this;
            axios.get('/darts_db/users/get_enabled_users.php', params).then(function (response) {
                console.log(response);

                for (let i = 0; i < response.data.length; i++) {
                    let player = {
                        id: response.data[i].id,
                        name: response.data[i].name,
                        singles: [],
                        doubles2x: [],
                        doubles3x: [],
                        triples2x: [],
                        triples3x: [],
                        shanghai: [],
                        robinhood: [],
                        bull: []
                    }
                    self.players.push(player);
                }
                self.getMilestones();

            }).catch(function (error) {
                console.log(error);
            });
        },

        getActiveSeason() {
            const params = {
                params: {
                    // user_id: '1'
                }
            }

            const self = this;
            axios.get('/darts_db/seasons/get_active_season.php', params).then(function (response) {
                console.log(response);
                self.season.id = response.data[0].id;
                self.season.name = response.data[0].name;
                self.loadUsers();
            }).catch(function (error) {
                console.log(error);
            });
            
        }

        

    },



    mounted() {
        this.getActiveSeason();
        


        var url_string = window.location.href;
        var url = new URL(url_string);
        var cat = url.searchParams.get("cat");
        this.category = cat
        console.log(this.category)

        // TODO: Check everyone's title's validity

    }
}
</script>


<style scoped>

    @font-face {
        font-family: SegoeUI;
        src: url("../../Segoe UI.ttf");
    }

    * {
        font-family: "SegoeUI";
        box-sizing: border-box;
    }
    
    html {
        overflow-x: hidden;
        margin: 0;
        padding: 0;
    }

    body {
        margin: 0;
        background: #444;
        color: #000;
        font-family: "SegoeUI";
        /*overflow-x: hidden;*/
        
        padding: 0;

    }

    

    .container {
        width: 1200px;
        margin: 0 auto;
        margin-top: 20px;
    }

    .touchscreen-outer {
        width: 1000px;
        height: 580px;
        display: flex;
        background: #000;
        border-radius: 10px;
    }
    .piscreen {
        width: 800px;

    }

    .topBar {

        background: #bbb;
        display: flex;
        height: 80px;
        /*align-items: center;*/
        /*border-bottom: 1px solid #bbb;*/
        position: relative;
        z-index: 1;
        box-shadow: 0px 1px 3px rgba(0,0,0,0.48);

    }
    .home {
        /*position: absolute;*/
        font-size: 32px;
        /*border: 1px solid #558b2f;*/
        border: 1px solid #222;
        margin: 10px 0 10px 10px;
        box-shadow: 1px 1px 3px rgba(0,0,0,0.24);
        /*background: #aed581;*/
        background: #555;
        border-radius: 3px;
        /*height: 60px;*/
        left: 0px;
        top: 0px;
        cursor: pointer;
        user-select: none;
    }
    .home a {
        text-decoration: none;
        padding: 5px 15px 10px;
        display: block;
        color: #fff;
    }
    .active a {
        color: gold;
    }
    .touchscreen {
        margin: auto;
        width: 800px;
        height: 480px;
        /*border: 1px solid blue;*/
        /*padding-top: 5px;*/
        position: relative;
        background: #fff;
        overflow: scroll;
        overflow-x: hidden;
    }

    .category {
        margin-top: 20px;
        position: relative;
    }
    .category:nth-child(2) {
        margin-top: 0;
    }
    .category:nth-child(2) header {
        padding-top: 8px;
    }
    .category.singles {
        margin-top: 0;
    }

    .category h2 {
        text-align: center;
        margin: 0;
        text-transform: uppercase;
    }

    .category p {
        margin: 0;
        font-size: 20px;
        text-align: center;
        /*color: black;*/
    }

    .category header {
        padding: 5px 5px 10px;
        text-shadow: 1px 1px 2px #000;
        margin-bottom: 2px;
        color: white;
    }

    #singles header {
        background: #558b2f;
    }
    #doubles2x header,
    #doubles3x header {
        background: #1565c0;
    }
    #triples2x header,
    #triples3x header {
        background: #673ab7;
    }
    #shanghai header {
        background: #ad1457;
    }
    #robinhood header {
        background: #ef6c00;
    }
    #bull header {
        background: #c62828;
        color: white;
    }

    #singles table tr td.enabled {
        background: #aed581;
        border: 1px solid #558b2f;
    }
    #doubles2x table tr td.enabled,
    #doubles3x table tr td.enabled {
        background: #64b5f6;
        border: 1px solid #1565c0;
    }
    #triples2x table tr td.enabled,
    #triples3x table tr td.enabled {
        background: #b39ddb;
        border: 1px solid #673ab7;
    }
    #shanghai table tr td.enabled {
        background: #f06292;
        border: 1px solid #ad1457;
    }
    #robinhood table tr td.enabled {
        background: #ffb74d;
        border: 1px solid #ef6c00;
    }
    #bull table tr td.enabled {
        background: #e57373;
        border: 1px solid #c62828;
    }

    div.player {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-right: 2px;
    }

    div.name,
    div.milestones {
        color: black;
    }

    div.name {
        width: 116px;
        text-align: right;
        color: #000 !important;
        padding-right: 5px;
        /*font-weight: bold;*/
        overflow: hidden;
    }



    table tr {
        border: 1px solid black;
    }

    table tr td {
        font-size: 16px;
        text-align: center;
        /*padding: 5px 10px;*/
        width: 32px;
        height: 32px;
        font-weight: bold;
        user-select: none;
    }

    table.bull tr td {
        width: auto;
        padding: 0 15px;
    }

    .player:nth-child(even) table tr td:not(.enabled) {
        background: #ddd;
        border: 1px solid #aaa;
    }
    .player:nth-child(odd) table tr td:not(.enabled) {
        background: #fff;
        border: 1px solid #ccc;
    }

    /*table tr td.enabled {
        background: #aed581;
        border: 1px solid #8bc34a;
    }*/

    .addButton {
        position: absolute;
        top: 0px;
        left: 0px;
        
        z-index: 1000;
        
    }
    .addButton a {
        display: block;
        /*width: 80px;*/
        height: 72px;
        font-size: 80px;
        padding: 12px 12px 12px 12px;
        line-height: 30px;
        text-shadow: 2px 2px 2px #000;
        color: #fff;
        text-decoration: none;
    }

    .category:last-child {
        margin-bottom: 20px;
    }



    .bull-icon {
        height: 16px;
        width: 16px;
        border-radius: 50%;
        display: inline-block;
        position: relative;
        border: 1px solid #444;
        margin-top: 5px;
        margin-left: 1px;
        margin-right: 1px;
        /*margin-right: 5px;*/
        /*box-shadow: 0px 0px 3px #444;*/
    }

    .bull-icon.hit {
        background-color: #00e676;
    }

    .bull-icon.miss {
        background-color: #efe;
    }
    .bullseye-icon.miss {
        background-color: #fee;
    }

    .bullseye-icon {
        height: 16px;
        width: 16px;
        border-radius: 50%;
        display: inline-block;
        position: relative;
        border: 1px solid #444;
        margin-top: 5px;
        margin-left: 1px;
        margin-right: 1px;

        /*box-shadow: 0px 0px 3px #444;*/
    }

    .bullseye-icon.hit {
        background: #ff1744;
    }

    .bottomMenu {
        background: #ddd;
        padding: 15px;
        margin-top: 25px;
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #aaa;
        align-items: center;
    }
    .menuButton {
        box-shadow: 1px 1px 3px rgba(0,0,0,0.48);
        background: #fff;
        border-radius: 10px;
        font-size: 36px;
        /*margin-left: auto;*/
        padding: 5px 15px;
        margin-right: 15px;
    }
    .optionsButton {

    }
    .logo {
        /*margin-right: auto;*/
    }
    .bottomMenu p {
        text-align: center;
        margin: 0;
    }
    .bottomMenu p:first-child {
        /*text-transform: uppercase;*/
        font-weight: bold;
    }
    .bottomMenu p:nth-child(2) {
        font-size: 0.9em;
    }

    .patchnotes {
        /*margin-right: 0px;*/
        width: 58px;
        height: 58px;
        font-size: 1.5em;
        line-height: 52px;
        text-align: center;
    }

    .patchnotes a {
        color: #333;
        width: 100%;
        height: 100%;
        display: block;
    }

    .adminButton {
        /*margin-right: 0px;*/
        width: 58px;
        height: 58px;
        
        border: 1px solid #ccc;
        background: white;
        color: black;
        border-radius: 50%;
        box-shadow: 1px 1px 3px rgba(0,0,0,0.48);
    }

    .adminButton a {
        display: block;
        text-decoration: none;
        padding: 10px 16px 16px;
        font-size: 24px;
    }

    /*.footerText {
        position: absolute;
        margin: 0 auto;
        display: inline-block;
    }*/

    nav.categories {
        display: flex;
        background: #ddd;
        align-items: center;
        position: sticky;
        top: 0;
        z-index: 1001;
        box-shadow: 0px 2px 3px rgba(0,0,0,0.25);
        /*justify-content: center;*/
        height: 68px;
    }

    nav.categories .nav-cat {
        display: flex;
        flex: 1;
        align-items: center;
        height: 52px;
        padding-bottom: 3px;
        border-right: 1px solid #bbb;
    }

    nav.categories .nav-cat:last-child {
        border-right: 0;
    }

    nav.categories .nav-cat div {
        flex: 1;
        text-align: center;
        /*font-weight: bold;*/
        /*text-transform: uppercase;*/
    }
        



</style>
